<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <div class="row margined-bottom">
                    <div class="col-md-12">
                        <label class="control-label">Users</label>
                    </div>
                    <div class="col-md-12 form-group">
                        <input type="hidden" name="user" v-model="user" :disabled="remoteAccessProvided">
                        <user-search-component
                            not-found-message="Customer not found. Consider changing the query."
                            :trigger-text="''"
                            :field="['email', 'full_name']"
                            :role="['customer_owner', 'customer_admin', 'customer_employee']"
                            :disabled="remoteAccessProvided"
                            :default-user-id="defaultUserId"
                            active-booking
                            active-checkin
                            :as-mail-input="true"
                            :centre_id="centre.id"
                        ></user-search-component>
                    </div>
                    <div class="col-md-12 form-group">
                        <label class="control-label">Booking reference</label>
                        <input type="hidden"
                               name="booking"
                               :value="titanSaleId">
                        <multiselect
                            v-model="selectedBooking"
                            :disabled="!user || remoteAccessProvided"
                            :options="bookings"
                            track-by="id"
                            label="titan_sale_id"
                            placeholder="Choose booking reference"
                            :allow-empty="true"
                            :multiple="false"
                            :close-on-select="true"
                            :style="{ height: 'auto'}"
                        >
                            <template #noResult>
                              <span>
                                  Booking not found. Consider changing the query.
                              </span>
                            </template>
                        </multiselect>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group margined-bottom">
                            <label class="control-label">Reason</label>
                            <select
                                name="reason"
                                class="form-control"
                                :disabled="!selectedBooking || remoteAccessProvided"
                                v-model="reason"
                            >
                                <option :value="null" disabled>Select a reason</option>
                                <option value="mkey_not_working">Mobile key not working</option>
                                <option value="mobile_not_working">Mobile Device not working</option>
                                <option value="wifi_down">Wi-Fi down</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-12 form-group margined-bottom" v-for="lockId in selectedLockIds" :key="lockId">
                        <remote-access-elock-component
                            :remoteAccessId="remoteAccessId"
                            :lockId="lockId"
                            :lockNumber="selectedLockIds.indexOf(lockId) + 1"
                            v-model:lockStates="lockStates"
                            :selectableLocks="selectableLocks"
                            :visible="remoteAccessProvided && lockStates[lockId]?.lock && !lockStates[lockId]?.unlocking"
                            :dropdownVisible="!reason || remoteAccessProvided"
                            btnClass="btn btn-xs btn-danger float-end h-margin-10"
                        ></remote-access-elock-component>

                    </div>

                    <div class="col-md-12 margined-bottom">
                        {{ explanation }}
                    </div>
                    <div class="row margined-bottom">
                        <div class="col-md-12">
                            <button class="btn btn-light"
                                    :disabled="disabled"
                                    v-if="!remoteAccessProvided"
                                    type="button"
                                    @click="grantRemoteAccess();">Grant remote access</button>

                            <a v-if="!remoteAccessProvided" class="btn btn-danger float-end" :href="previousUrl">Cancel</a>

                            <button class="btn btn-light"
                                    :disabled="disabled || disableSubmitButton"
                                    v-if="remoteAccessProvided"
                                    type="button"
                                    @click="finish();">Submit and finish</button>

                            <button class="btn btn-light float-end"
                                    :disabled="disabled"
                                    v-if="remoteAccessProvided && showProvideAccessButton"
                                    type="button"
                                    @click="provideAnotherAccess()">Provide another access</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {EventBus} from '../../EventBus';
import UserSearchComponent from '../Shared/UserSearchComponent.vue';
import Multiselect from 'vue-multiselect';
import differenceBy from "lodash/differenceBy";
import Endpoints from '../../Config/Endpoints';
import API from '../../Services/API';

export default {
    name: "CustomAccessFormComponent",
    components: {
        UserSearchComponent,
        Multiselect
    },
    props: {
        centre: {
            required: true,
            type: Object
        },
        maxLockAmount: {
            type: Number,
            default: 5
        },
        previousUrl: {
            type: String,
            required: true,
        },
        remoteAccess: {
            type: Object,
            default: null
        },
        explanation: {
            type: String,
            required: true
        }
    },
    mounted() {
        EventBus.on('user-selected', this.userSelected);
        EventBus.on('unlock', (payload) => {
            this.unlock(payload.lock, payload.lockId);
        });
        EventBus.on('error-btn-clicked', () => this.disableSubmitButton = true);
        EventBus.on('error-reason-selected', () => this.disableSubmitButton = false);
    },
    data() {
        return {
            user: null,
            selectedBooking: null,
            reason: null,
            bookings: [],
            availableLocks: [],
            lockStates: {},
            selectedLockIds: [],
            remoteAccessProvided: false,
            remoteAccessId:null,
            disableSubmitButton: false
        }
    },
    computed: {
        titanSaleId() {
            return this.selectedBooking?.titan_sale_id
        },
        bookingId() {
            return this.selectedBooking?.id
        },
        disabled() {
            return this.selectedLockIds.filter(lockId => this.lockStates[lockId]?.lock).length === 0;
        },
        selectableLocks() {
            const selectedLocks = this.selectedLockIds
                .map(lockId => this.lockStates[lockId]?.lock)
                .filter(Boolean);

            return this.availableLocks.map(({name, locks}) => {
                return {
                    name,
                    locks: differenceBy(locks, selectedLocks, 'id')
                }
            })
        },
        showProvideAccessButton(){
            return this.selectedLockIds.length < this.maxLockAmount;
        },
        defaultUserId(){
            return this.remoteAccess?.requester.id
        },
        editPage(){
            return this.remoteAccess !== null
        }
    },
    methods: {
        generateLockId() {
            return 'lock_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
        },
        addNewLock() {
            const lockId = this.generateLockId();
            this.selectedLockIds.push(lockId);
            this.lockStates[lockId] = {
                lock: null,
                unlocking: false,
                grantBtnState: false,
                grantBtnDisabled: false,
                unreachedDisabled: false,
                tryAgainDisabled: false,
                errorBtnDisabled: false,
                errorBtnClicked: false,
                isUnreached: false
            };
        },
        userSelected(user) {
            this.user = user.id
            axios.get(
                API.url(Endpoints.RemoteAccess.GetActiveBookingReferences, {centre_id: this.centre.id, user_id: user.id})
            ).then((res) => {
                this.bookings = res.data.bookings
                if(res.data.has_checkin) {
                    this.bookings.push({
                        id: null,
                        titan_sale_id: 'Lounge'
                    })
                }

                if (this.editPage) {
                    this.fillTheForm();
                }

            });
        },
        grantRemoteAccess() {
            if (!confirm("Are you sure?")) {
                return;
            }

            const selectedLocks = this.selectedLockIds
                .map(lockId => this.lockStates[lockId]?.lock)
                .filter(Boolean);

            axios.post(
                API.url(Endpoints.RemoteAccess.Store),
                {
                    centre_id: this.centre.id,
                    requester_id: this.user,
                    reason: this.reason,
                    booking_id: this.bookingId,
                    locks: selectedLocks.map(lock => lock.id),
                }
            ).then((res) => {
                this.remoteAccessId = res.data.id;
                this.remoteAccessProvided = true;
                this.selectedLockIds = this.selectedLockIds.filter(lockId =>
                    this.lockStates[lockId]?.lock
                );
                this.selectedLockIds.forEach(lockId => {
                    const lock = this.lockStates[lockId]?.lock;
                    if (lock) {
                        this.unlock(lock, lockId);
                    }
                });
            });
        },
        async unlock(lock, lockId) {
            this.lockStates[lockId] = {
                ...this.lockStates[lockId],
                unlocking: true
            };

            await axios.post(
                API.url(Endpoints.RemoteAccess.Unlock,{ remote_access_id: this.remoteAccessId, lock_id: lock.id }),
            ).then((res)=>{
                if(res.data.error !== null){
                    alert(res.data.error)
                }
            });

            this.lockStates[lockId] = {
                ...this.lockStates[lockId],
                unlocking: false
            };

            this.disableSubmitButton = false
        },
        finish() {
            if (!confirm("Are you sure?") || !this.remoteAccessId) {
                return;
            }
            axios.post(
                API.url(Endpoints.RemoteAccess.Finish,{ remote_access_id: this.remoteAccessId})
            ).then((res) => {
                if(res.data.error !== null){
                    alert(res.data.error)
                    return;
                }
                window.location.href = res.data.redirectRoute;
            });
        },
        provideAnotherAccess(){
            const lockId = this.generateLockId();
            this.selectedLockIds.push(lockId);
            this.lockStates[lockId] = {
                lock: null,
                unlocking: false,
                grantBtnState: true,
                grantBtnDisabled: true,
                unreachedDisabled: false,
                tryAgainDisabled: false,
                errorBtnDisabled: false,
                errorBtnClicked: false,
                isUnreached: false
            };
            this.disableSubmitButton = true;
        },
        fillTheForm(){
            this.remoteAccessId = this.remoteAccess.id

            if(this.remoteAccess.booking === null){
                this.selectedBooking = {"id":null,"titan_sale_id":"Lounge"};
            }else {
                this.selectedBooking = this.bookings.filter((b) => b.id === this.remoteAccess.booking.id)[0]
            }
            this.reason = this.remoteAccess.reason.key
            this.lockStates = {};
            this.selectedLockIds = [];
            this.remoteAccess.locks.forEach((lock) => {
                const lockId = this.generateLockId();
                this.selectedLockIds.push(lockId);
                if(lock.outcome === "rejected" && lock.solution !== null){
                    EventBus.emit("error-selected", lock);
                }

                this.lockStates[lockId] = {
                    lock: lock,
                    unlocking: false,
                    grantBtnState: false,
                    grantBtnDisabled: false,
                    unreachedDisabled: lock.outcome === "unreached",
                    tryAgainDisabled: lock.outcome === "unreached",
                    errorBtnDisabled: lock.outcome === "unreached",
                    errorBtnClicked: false,
                    isUnreached: lock.outcome === "unreached"
                };
            });


            this.remoteAccessProvided = true;
        }
    },
    watch: {
        titanSaleId() {
            if(!this.editPage) {
                this.lockStates = {};
                this.selectedLockIds = [];
                for(let i = 0; i < this.maxLockAmount; i++) {
                    this.addNewLock();
                }
            }
            axios.post(
                API.url(Endpoints.RemoteAccess.Locks, {
                    centre_id: this.centre.id
                }),
                {
                    titan_sale_id: this.titanSaleId
                }
            ).then((res) => {
                this.availableLocks = res.data.data
            });
        }
    }
}
</script>
